import { Mask } from '../mask.interface';

export class CreditCardCVVModel implements Mask {

  private creditCardCVVMask = [/\d/, /\d/, /\d/, /\d/];

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.creditCardCVVMask;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/creditCardCVV.model.ts